import React, { useState, useEffect, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import logo from '../images/logo.jpeg'
import { FaHouseChimney } from "react-icons/fa6"
import { FaInfoCircle } from "react-icons/fa"
import { IoMdText } from "react-icons/io"
import { MdPreview } from "react-icons/md"

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const navRef = useRef(null)
  const btnRef = useRef(null)

  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isOpen &&
        navRef.current &&
        !navRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [isOpen])


  const handleLinkClick = () => {
    setIsOpen(false)
  }

  return (
    <div className="nav">
      <div className="logo">
        <img src={logo} alt="logo" />
        <h1>BM MATHEBULA</h1>

        <div ref={navRef} className={`navbar ${isOpen ? "active" : ""}`}>
          <ul>
            <li>
              <NavLink to="/" onClick={handleLinkClick}>
                <span className="icon"><FaHouseChimney /></span>
                <span className="text">HOME</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={handleLinkClick}>
                <span className="icon"><FaInfoCircle /></span>
                <span className="text">ABOUT US</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/book" onClick={handleLinkClick}>
                <span className="icon"><IoMdText /></span>
                <span className="text">BOOK US</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/Reviews" onClick={handleLinkClick}>
                <span className="icon"><MdPreview /></span>
                <span className="text">REVIEWS</span>
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Menu button */}
        <div
          ref={btnRef}
          className={`menu-btn ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className="head">
        <h2>SUPPORT SERVICE AND WELLNESS</h2>
        <h3>
          Empowering lives through<br />
          holistic psychological support
        </h3>
      </div>
    </div>
  )
}

export default NavBar
